module.exports = __webpack_public_path__ + "img/online.e17a825b.svg";